import styled from "styled-components";

export const Select = styled.select`
  background-color: #202127;
  color: #f88702;
`;
